module.exports = __webpack_public_path__ + "img/2-3.a1eea220.svg";